// Invoice Checker Frontend Configuration

const isProduction = process.env.NODE_ENV === 'production';

export const config = {
    // Portal API (Auth)
    PORTAL_API_URL: process.env.REACT_APP_PORTAL_API_URL || 'http://localhost:5002',

    // Invoice Checker API
    INVOICE_API_URL: process.env.REACT_APP_INVOICE_API_URL || 'http://localhost:5003',

    // Portal Frontend (for redirects)
    PORTAL_URL: process.env.REACT_APP_PORTAL_URL || 'http://localhost:3001',
};

export const API_ENDPOINTS = {
    // Auth endpoints (point to Portal)
    AUTH_ME: `${config.PORTAL_API_URL}/api/auth/me`,
    USERS: `${config.PORTAL_API_URL}/api/users`,
    VALIDATE_TOKEN: `${config.PORTAL_API_URL}/api/auth/validate-token`,

    // Invoice endpoints (point to Invoice Checker backend)
    INVOICES: `${config.INVOICE_API_URL}/api/invoices`,
    INVOICE_DETAIL: (id: string) => `${config.INVOICE_API_URL}/api/invoices/${id}`,

    // Local API for user verification
    ME: `${config.INVOICE_API_URL}/api/me`,

    // RFQ endpoints
    COMPLETED_RFQS: `${config.INVOICE_API_URL}/api/invoices/completed-rfqs`,
    RFQS: `${config.INVOICE_API_URL}/api/invoices/rfq`,
    INVOICE: `${config.INVOICE_API_URL}/api/invoices/invoice`,
};

export default config;
